import CategoryCard from '@stories/Components/CategoryCard/CategoryCard';
import SectionHeader from '@stories/Components/SectionHeader/SectionHeader';
import * as React from 'react';
import S from './CategoryCards.styles';
const CategoryCards = ({ anchorId, items, ...rest }) => {
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(SectionHeader, { ...rest }),
        React.createElement(S.Items, null, items.map((item) => (React.createElement(CategoryCard, { key: `category-card-${item.id}`, ...item }))))));
};
export default CategoryCards;
